import { convertUTCtoMSK } from '../../../../../../../utils'
import { IMessageTemplateMatcher } from '../../core/response.types'

interface Props {
  matcher: IMessageTemplateMatcher
}

export default ({ matcher }: Props) => {
    return (
        <tr>
            <td>{matcher.regex}</td>
            <td>{matcher.mask || '-'}</td>
            <td>{convertUTCtoMSK(matcher.createdAt)}</td>   
            <td>{matcher.matchCount}</td>
            <td>{matcher.lastMatchAt ? convertUTCtoMSK(matcher.lastMatchAt) : '-'}</td>
        </tr>
    )
}
